import React from 'react';
import loader from './loader.svg';

const OpacityPreLoaderLittle = () => (
  <div>
    <div className="loader loader-overlay">
      <div className="loader-icon spinning-cog loader-icon-sm">
        <img alt="Загрузка" src={loader} />
      </div>
    </div>
  </div>
);
export default OpacityPreLoaderLittle;



// WEBPACK FOOTER //
// ./src/components/Common/PreLoaders/OpacityPreLoaderLittle.js